import {
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Spin,
  Typography,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../../../assets/styles/DatePicker.css";
import CustomButton from "../../../components/custom/CustomButton";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import appLabel from "../../../config/appLabel";
import { rightAction } from "../../../redux/actions";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import { apiConfig } from "../teller.config";

const { Text, Title } = Typography;

const TLO0500 = (props) => {
  const { userData } = props;
  const { session } = userData;
  console.log(userData, " userData");
  const [form] = Form.useForm();

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [currencyList, setCurrencyList] = useState([]);
  const [tillBatchId, setTillBatchId] = useState([]);

  function onCancel() {
    navigate("/dashboard", { replace: false });
  }

  const onSubmit = (values) => {
    const payload = {
      ...values,
      action: "SND",
      txnType: "SND",
      transactionDate: BOM.DateTime(values.transactionDate, "only-date"),
      isClientTrx: false,
      office: userData.officeId,
      status: "U",
      tillBatchId: tillBatchId,
      method: "POST",
      session,
      locale: "en",
      dateFormat: "dd MMMM yyyy",
    };

    const url = `${apiConfig.Transaction}?officeId=${userData?.officeId}`;

    setIsLoading(true);
    BOM.FetchReqAction(payload, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Sent cash successfully");
        setIsLoading(false);
        navigate("/tlo0400");
      }
    });
  };

  const getTemplate = () => {
    let body = {
      session: userData.session,
    };

    const url = `${apiConfig.Transaction}/template?officeId=${userData?.officeId}`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        let tempCurrencyOptions = [];

        objList?.currencyCodes?.forEach((code) => {
          tempCurrencyOptions.push({
            label: code,
            value: code,
          });
        });

        setCurrencyList(tempCurrencyOptions);
        setTillBatchId(objList?.tellerBatchMasts[0]?.batchId);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  useEffect(() => {
    getTemplate();
    form.setFieldsValue({
      office: userData.officeName,
      transactionDate: dayjs(),
    });
  }, []);

  return (
    <MainLayout isEnableRightSidebar={false}>
      <TopContent pageTitle="Send Cash" pageItems={[{ title: "Send Cash" }]} />
      <Spin spinning={isLoading} size="large">
        <Card
          title={
            <Title level={4} style={{ color: "#000" }}>
              Send Cash
            </Title>
          }
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={form} layout="vertical" onFinish={onSubmit}>
            <Card
              style={{
                marginBottom: "3%",
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
              }}
              bordered
            >
              <Card
                style={{
                  marginBottom: "0%",
                  boxShadow: "none",
                }}
              >
                <Row>
                  <Col span={12} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      name="office"
                      label={<Text strong>Office</Text>}
                      rules={[
                        {
                          required: true,
                          message: "Required Field",
                        },
                      ]}
                    >
                      <Input
                        disabled
                        className="of-bold-disable-input"
                        style={{ height: 44 }}
                        placeholder={BOM.handlePlaceholderMsg(appLabel.office)}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      name="transactionDate"
                      label={<Text strong>Transaction Date</Text>}
                      rules={[
                        {
                          required: true,
                          message: "Required Field",
                        },
                      ]}
                    >
                      <DatePicker style={{ width: "100%", height: 44 }} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={12} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      name="amount"
                      label={<Text strong>Amount</Text>}
                      rules={[
                        {
                          required: true,
                          message: "Required Field",
                        },
                      ]}
                    >
                      <InputNumber
                        formatter={BOM.FormatAmount}
                        parser={BOM.ParseAmount}
                        placeholder={BOM.handlePlaceholderMsg(appLabel.amount)}
                        style={{ width: "100%", height: 44, paddingTop: 7 }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      name="currencyCode"
                      label={<Text strong>Currency</Text>}
                      rules={[
                        {
                          required: true,
                          message: "Required Field",
                        },
                      ]}
                    >
                      <Select
                        options={currencyList}
                        placeholder={BOM.handlePlaceholderMsg(
                          appLabel.currency,
                        )}
                        style={{ height: 44 }}
                        showSearch
                        allowClear
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={24} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      name="txnNote"
                      label={<Text strong>Note</Text>}
                      rules={[
                        {
                          required: true,
                          message: "Required Field",
                        },
                      ]}
                    >
                      <TextArea
                        placeholder={BOM.handlePlaceholderMsg("note")}
                        style={{ height: 120, resize: "none" }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
              <Form.Item>
                <Row style={{ marginTop: 20 }}>
                  <CustomButton
                    content="Submit"
                    style={{
                      width: "120px",
                      marginLeft: "auto",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    }}
                    htmlType="submit"
                    backgroundColor="#15CCAE"
                    colorText="black"
                    hoverBackground="#4FECA0"
                  />
                  <CustomButton
                    content="Cancel"
                    style={{
                      width: "120px",
                      marginLeft: "1%",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    }}
                    backgroundColor="#fff"
                    colorText="black"
                    hoverBackground="#F5F5F5"
                    onClick={onCancel}
                  />
                </Row>
              </Form.Item>
            </Card>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };

export default connect(mapStateToProps, mapDispatchToProps)(TLO0500);
